// Module
var code = "<script>let $ctrl</script> <molecule-panel-wizard panel-title=\"Produktauswahl\"> <panel-body> <molecule-form-item-select-new-generic account=\"$ctrl.selectedAccount\" selected-item=\"$ctrl.selectedProduct\" items=\"$ctrl.wizardSelection\"></molecule-form-item-select-new-generic> </panel-body> </molecule-panel-wizard> ";
// Exports
module.exports = code;